var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"20px"}},[_c('div',{staticClass:"question"},[_c('div',{staticClass:"question-margin"},[_c('quessionnaire-tile',{attrs:{"title":_vm.questions}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }